import React, { useState } from "react";
import { TextField, Button, Checkbox, FormControlLabel } from "@material-ui/core";
import FilePickerDialog, {
  ImageExtensions,
} from "../../components/file-picker-dialog/file-picker-dialog.view";
import { getFileUrl } from "../../common/tools";

const patternEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Các field bổ sung của Chủ đầu tư (dùng chung cho form thêm và sửa).
 * logo: { fileId, fileName, filePreview } | null (dạng Files, giống logoFile backend trả về)
 */
const InvestorExtraFields = ({
  register,
  errors,
  defaultValues = {},
  logo,
  setLogo,
  isActive,
  setIsActive,
  canClearLogo = true,
}) => {
  const [isShowPicker, setIsShowPicker] = useState(false);

  const renderTextField = (name, label, maxLength, rules = {}) => (
    <div className="form-group col-md-6">
      <label className="text-dark">{label}</label>
      <TextField
        inputRef={register({ maxLength, ...rules })}
        name={name}
        error={!!errors[name]}
        fullWidth
        type="text"
        className="form-control"
        inputProps={{ maxLength }}
        defaultValue={defaultValues[name] || ""}
      />
      {errors[name] && errors[name].type === "maxLength" && (
        <span className="error">Tối đa {maxLength} ký tự</span>
      )}
      {errors[name] && errors[name].type === "pattern" && (
        <span className="error">{errors[name].message}</span>
      )}
    </div>
  );

  return (
    <>
      <div className="row">
        {renderTextField("shortName", "Tên viết tắt", 100)}
        {renderTextField("taxCode", "Mã số thuế", 50)}
        {renderTextField("email", "Email", 255, {
          pattern: { value: patternEmail, message: "Email không hợp lệ" },
        })}
        {renderTextField("website", "Website", 500)}
      </div>
      <div className="form-group">
        <label className="text-dark">Giới thiệu</label>
        <textarea
          name="description"
          rows="3"
          ref={register()}
          className="form-control"
          defaultValue={defaultValues.description || ""}
        />
      </div>
      <div className="form-group">
        <label className="text-dark d-block">Logo</label>
        <div className="d-flex align-items-center">
          <div
            className="mr-3 d-flex align-items-center justify-content-center bg-light border"
            style={{ width: 120, height: 80 }}
          >
            {logo && logo.filePreview ? (
              <img
                src={getFileUrl(logo.filePreview)}
                alt={logo.fileName}
                style={{ maxWidth: "100%", maxHeight: "100%" }}
              />
            ) : (
              <small className="text-muted">Chưa có logo</small>
            )}
          </div>
          <Button
            type="button"
            variant="contained"
            color="primary"
            className="mr-2"
            onClick={() => setIsShowPicker(true)}
          >
            Chọn logo
          </Button>
          {logo && canClearLogo && (
            <Button type="button" variant="contained" onClick={() => setLogo(null)}>
              Bỏ logo
            </Button>
          )}
        </div>
      </div>
      <FormControlLabel
        control={
          <Checkbox
            checked={isActive}
            onChange={(e) => setIsActive(e.target.checked)}
            color="primary"
          />
        }
        label="Hoạt động (tắt thì không còn trong danh sách chọn chủ đầu tư)"
      />

      {isShowPicker && (
        <FilePickerDialog
          isOpen={isShowPicker}
          onClose={() => setIsShowPicker(false)}
          onConfirm={(files) => setLogo(files[0])}
          acceptedFiles={ImageExtensions}
          title="Chọn logo"
        />
      )}
    </>
  );
};

/** Gắn các field bổ sung vào FormData. Backend: field rỗng hoặc không gửi thì giữ giá trị cũ. */
export const appendInvestorExtraFields = (formData, data, logo, isActive) => {
  ["shortName", "taxCode", "email", "website", "description"].forEach((field) => {
    const value = (data[field] || "").trim();
    value && formData.append(field, value);
  });
  logo && logo.fileId && formData.append("logoFileId", logo.fileId);
  formData.append("isActive", isActive ? "true" : "false");
};

export default InvestorExtraFields;
